import * as styles from "./ToggleGroup.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { ToggleGroup as BaseToggleGroup } from "@base-ui/react/toggle-group";

import {
  ToggleGroupContext,
  makeToggleGroupContext,
} from "./ToggleGroup.context";
import type { ToggleGroupProps } from "./ToggleGroup.types";

export function ToggleGroup({
  variant,
  orientation = "horizontal",
  fill,
  className,
  ...props
}: ToggleGroupProps): JSX.Element {
  return (
    <ToggleGroupContext.Provider
      value={makeToggleGroupContext({ variant, orientation })}
    >
      <BaseToggleGroup
        data-slot="toggle-group"
        orientation={orientation}
        className={clsx(
          styles.toggleGroup({ variant, orientation, fill }),
          className,
        )}
        {...props}
      />
    </ToggleGroupContext.Provider>
  );
}
